import React from "react";
import StatusBadge from "./StatusBadge";
import ProfileModal from "../../TransporterClientScreen/ProfileModal/ProfileModal";


/* Auto Allocation View */
const AllocationCard = ({ data, item }) => {
  const lspInfo = item?.indent_info?.shortlisted_transporters?.find(
    (lsp) => lsp.transporter_id === data.transporter_id
  );

  const lspRate = data?.rate ?? lspInfo?.rate ?? "";
  const lspRank = data?.rank ?? lspInfo?.rank ?? "";

  const isPmIndent =
    item?.indent_type === "private_market_place_indent" ?? false;

  // console.log(lspRate);

  return (
    <div
      className="bg-white d-flex justify-content-between align-items-center p-4 w-100"
      style={{ border: "1px solid #CCCCCC", borderRadius: "8px" }}
    >
      <div className="w-100 d-flex flex-column" style={{ gap: "5px" }}>
        <div className="d-flex align-items-start">
          <ProfileModal
            style={{ margin: 0, padding: 0, textAlign: "left" }}
            transporter_list={item?.summary}
            transporter_id={data?.transporter_id}
            transporter_name={data?.transporter_name}
            screenName={"Indent Request"}
            moduleName={"LoRRI Indents"}
          />
          {lspRank && (
            <span
              className="ml-2 text-muted"
              style={{ fontSize: "14px", fontWeight: "600", whiteSpace: "nowrap"}}
            >
              ({lspRank})
            </span>
          )}
        </div>
        <StatusBadge status={data?.indent_status} />
      </div>
      <div
        className="d-flex flex-column align-items-end w-100"
        style={{ gap: "5px" }}
      >
        {lspRate !== "" ? (
          <div>
            <i className="fas fa-rupee-sign mr-1"></i>
            {`${lspRate} /-`}
          </div>
        ) : isPmIndent ? (
          "No quote available"
        ) : (
          "--"
        )}
        <div>
          <i className="fas fa-truck	mr-1"></i>
          {data?.allocation?.allocated_truck ?? 0}
        </div>
      </div>
    </div>
  );
};

export default AllocationCard;
